import ApiService from '@/services/api'
import { defineStore } from 'pinia'
//import { taskUpdateService } from '@/rxjsServices';

const ENDPOINT = '/tasks/'
const ITEM_ID  = 'tsk_uid'

export const useTaskStore = defineStore('tasks', {
  // convert to a function
  state: () => ({
    item: { tsk_duration:'', tsk_customfields: {}, _pivot: { tasktypes: [], users: [], equipments: [] }  },
    itemList: [],
    itemDayList: [],
    itemGraphList: []
  }),
  getters: {

  },
  actions: {
    fetchItem (id, options) {
        return new Promise( (resolve, reject) => {
            options = (options) ? '/' + options : ''
            if( id && id.length > 8 ){
                ApiService.get(ENDPOINT + id + options).then( (response) => {
                    if( !response.data.data.tsk_customfields || Object.prototype.toString.call( response.data.data.tsk_customfields ) === '[object Array]' ) {
                        response.data.data.tsk_customfields = {}
                    }
                    this.SET_ITEM(response.data.data)
                    resolve(this.item)
                }).catch( (error) => { 
                    reject(error)
                })
            } else {
                this.RESET_ITEM()
                resolve(this.item)
            }
        })
    },
    fetchItems (options) {
        return new Promise( (resolve, reject) => {
            this.SET_ITEMS([])
            options = (options) ? options : ''
            ApiService.get( ENDPOINT + options ).then( (response) => {
                this.metaTask = response.data.meta
                if( Object.prototype.toString.call( response.data.data ) === '[object Array]' ) {
                    this.SET_ITEMS(response.data.data)
                }
                resolve('resolved')
            }).catch( (error) => { 
                reject(error)
            })
        })
    },
    fetchGraphItems (options) {
        return new Promise( (resolve, reject) => {
            this.SET_GRAPHITEMS([])
            options = (options) ? options : ''
            ApiService.get( ENDPOINT + options ).then( (response) => {
                this.metaGraphTask = response.data.meta
                if( Object.prototype.toString.call( response.data.data ) === '[object Array]' ) {
                    this.SET_GRAPHITEMS(response.data.data)
                }
                resolve('resolved')
            }).catch( (error) => { 
                reject(error)
            })
        })
    },
    fetchDayItems (options) {
        return new Promise( (resolve, reject) => {
            this.SET_DAY_ITEMS([])
            options = (options) ? options : ''
            ApiService.get( ENDPOINT + options ).then( (response) => {
                this.metaTask = response.data.meta
                if( Object.prototype.toString.call( response.data.data ) === '[object Array]' ) {
                    this.SET_DAY_ITEMS(response.data.data)
                }
                resolve('resolved')
            }).catch( (error) => { 
                reject(error)
            })
        })
    },
    storeItem () {
        return new Promise( (resolve, reject) => {
            ApiService.post( ENDPOINT, this.item ).then( (response) => {
                this.SET_ITEM(response.data)
                resolve(this.item)
            }).catch( (error) => { 
                reject(error)
            })
        })
    },
    updateItem () {
        return new Promise( (resolve, reject) => {
            ApiService.put( ENDPOINT + this.item[ITEM_ID], this.item ).then( (response) => {
                this.SET_ITEM(response.data)
                resolve(this.item)
            }).catch( (error) => { 
                reject(error)
            })
        })
    },
    restoreItem (item) {
        return new Promise( (resolve, reject) => {
            if(item){
                this.SET_ITEM(item)
            }
            ApiService.put( ENDPOINT + this.item[ITEM_ID] + '/restore', this.item ).then( (response) => {
                this.SET_ITEM(response.data)
                resolve(this.item)
            }).catch( (error) => { 
                reject(error)
            })
        })
    },
    destroyItem (id) {
        return new Promise( (resolve, reject) => {
            this.item[ITEM_ID] = (id) ? id : this.item[ITEM_ID]
            ApiService.delete(ENDPOINT + this.item[ITEM_ID]).then( () => {
                this.RESET_ITEM()
                resolve('resolved')
            }).catch( (error) => { 
                reject(error)
            })
        })
    },
    downloadItems(options, fileName){
        return new Promise( (resolve, reject) => {
            options = (options)  ? options : ''
            fileName= (fileName) ? fileName : 'rapport'
            ApiService.customRequest({ method: 'get', url: '/report/tasks/' + options, responseType: 'blob' } ).then( (response) => {
                //this.$download(response.data, fileName + ".xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")
                resolve(response.data)
            }).catch( (error) => { 
                reject(error)
            })
        })
    },
    //***************************MUTATIONS ***************************************/
    SET_ITEM (item) {
      this.item = item
      this.item._pivot= {}
      this.item._pivot['tasktypes']  = (this.item.tasktypes) ? [...this.item.tasktypes.map(a => a['tty_id'])] : []
      this.item._pivot['users']      = (this.item.users) ? [...this.item.users.map(a => a['id'])] : []
      this.item._pivot['equipments'] = (this.item.equipments) ? [...this.item.equipments.map(a => a['equ_id'])] : []
      this.item.tsk_time_plan = (this.item.tsk_time_plan) ? this.item.tsk_time_plan.substring(0,5) : this.item.tsk_time_plan
      this.item.tsk_time_end = (this.item.tsk_time_end) ? this.item.tsk_time_end.substring(0,5) : this.item.tsk_time_end
      this.item.tsk_duration_plan = (this.item.tsk_duration_plan) ? this.item.tsk_duration_plan.substring(0,5) : this.item.tsk_duration_plan
      this.item.tsk_duration = (this.item.tsk_duration) ? this.item.tsk_duration.substring(0,5) : this.item.tsk_duration
    },
    SET_ITEMS (itemList) {
      this.itemList = itemList
    },
    SET_GRAPHITEMS (itemList) {
      this.itemGraphList = itemList
    },
    SET_DAY_ITEMS (itemList) {
        this.itemDayList = itemList
    },
    RESET_ITEM () {
        this.item = {
            tsk_sta_id: 'TSK04', tsk_typ_id: 'TSK01', tsk_customfields : {}, tsk_date_plan: null, tsk_duration_plan: '01:00', tsk_duration: '00:00', 
            _pivot: { tasktypes: [], users: [], equipments: [] } 
        }
    }
  }
})
